import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {makeStyles, Theme, createStyles} from "@material-ui/core/styles";
import {RootState} from "../features/store";
import {sidebarToggleAction} from "../features/sliceReducer/interactionReducer";
import {useNavigate} from "react-router-dom";
import {Box, List, ListItem, ListItemIcon, ListItemText, Collapse} from "@material-ui/core";

import InboxIcon from "@material-ui/icons/Inbox";
import LocationCityIcon from "@material-ui/icons/LocationCity";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

interface sidebarProps {
  visible: string;
}

const SideBarContainer = styled(Box)<sidebarProps>`
  z-index: 200;
  position: fixed;
  overflow: hidden;
  left: ${(props) => (props.visible === "true" ? 0 : "-300px")};
  width: 300px;
  height: 100vh;
  padding: 0 20px;
  color: ${({theme}) => theme.palette.primary.main};
  background-color: ${({theme}) => theme.palette.gray.light};
  transition: all 0.3s ease;
  box-shadow: 0px 5px 20px ${({theme}) => theme.palette.gray.light};
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: "100%",
      maxWidth: 300,
      backgroundColor: theme.palette.background.paper,
    },
    logoAlign: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "60px",
      marginBottom: "20px",
    },

    nested: {
      paddingLeft: theme.spacing(1),
    },
    iconColor: {
      color: theme.palette.success.light,
    },
    menuSelect: {
      color: "#000",
      borderRadius: "5px",
      boxShadow: " 0px 5px 20px #bbbbbb ",
      transition: "all 0.3s ease",
      fontWeight: "bold",

      "& ListItemText": {
        fontWeight: "bold",
        color: "red",
        fontSize: "24px",
      },
    },
    iconSelect: {
      color: theme.palette.success.dark,
    },
  })
);

const SideBar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {sidebarToggle} = useSelector((state: RootState) => state.interaction);
  const [menuSelect, setMenuSelect] = useState<boolean>(false);
  const menuHandleClick = () => {
    setMenuSelect(!menuSelect);
  };
  return (
    <SideBarContainer visible={sidebarToggle.toString()} className={classes.list}>
      <section className={classes.logoAlign}></section>
      <section>
        <List component="nav">
          <ListItem
            button
            onClick={menuHandleClick}
            className={menuSelect ? classes.menuSelect : ""}
          >
            <ListItemIcon>
              <InboxIcon className={menuSelect ? classes.iconSelect : classes.iconColor} />
            </ListItemIcon>
            <ListItemText primary="자체감사" />
            {menuSelect ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={menuSelect} timeout="auto" unmountOnExit className={classes.nested}>
            <List
              component="div"
              disablePadding
              onClick={() => {
                dispatch(sidebarToggleAction());
              }}
            >
              <Link to="/">
                <ListItem button>
                  <ListItemIcon>
                    <InboxIcon className={classes.iconColor} />
                  </ListItemIcon>
                  <ListItemText primary="내 프로젝트" />
                </ListItem>
              </Link>
            </List>
            <Link to="/inspect/FactoryList">
              <List
                component="div"
                disablePadding
                onClick={() => {
                  dispatch(sidebarToggleAction());
                }}
              >
                <ListItem button>
                  <ListItemIcon>
                    <LocationCityIcon className={classes.iconColor} />
                  </ListItemIcon>
                  <ListItemText primary="사업장 관리" />
                </ListItem>
              </List>
            </Link>

            {/* <List
              component="div"
              disablePadding
              onClick={() => {
                dispatch(sidebarToggleAction());
              }}
            >
              <ListItem button onClick={() => navigate("manageProject")}>
                <ListItemIcon>
                  <DraftsIcon className={classes.iconColor} />
                </ListItemIcon>
                <ListItemText primary="우수사례 관리" />
              </ListItem>
            </List> */}
          </Collapse>
        </List>
      </section>
    </SideBarContainer>
  );
};

export default SideBar;
